import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import WhatsAppButton from "@/components/feature/WhatsAppButton";
import CookieBanner from "@/components/feature/CookieBanner";
import HeroSection from "./components/HeroSection";
import CategoriesSection from "./components/CategoriesSection";
import UpcomingEventsSection from "./components/UpcomingEventsSection";
import FeaturedTours from "./components/FeaturedTours";
import DestinationsSection from "./components/DestinationsSection";
import Testimonials from "./components/Testimonials";
import ProviderCTA from "./components/ProviderCTA";

export default function Home() {
  const { t, i18n } = useTranslation("home");
  useEffect(() => {
    document.title = t("pageTitle");
  }, [t, i18n.language]);

  return (
    <div className="min-h-screen bg-offwhite font-body">
      <Header />
      <main>
        <HeroSection />
        <CategoriesSection />
        <UpcomingEventsSection />
        <FeaturedTours />
        <DestinationsSection />
        <Testimonials />
        <ProviderCTA />
      </main>
      <Footer />
      <WhatsAppButton />
      <CookieBanner />
    </div>
  );
}